import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

const variants: Record<string, string> = {
  primary: 'bg-nk-navy text-white border-2 border-nk-navy hover:bg-black disabled:opacity-40',
  secondary: 'bg-white text-nk-navy border-2 border-slate-400 hover:bg-slate-100',
  ghost: 'bg-transparent text-nk-navy border-2 border-transparent hover:bg-slate-100 hover:border-slate-200',
  outline: 'bg-white text-nk-navy border-2 border-slate-400 hover:bg-slate-50',
  danger: 'bg-red-700 text-white border-2 border-red-800 hover:bg-red-800',
}

const sizes: Record<string, string> = {
  icon: 'size-9 shrink-0 rounded-md p-0 text-[14px] font-bold',
  sm: 'h-9 px-3 rounded-none text-[13px] font-bold leading-none',
  md: 'h-10 px-4 rounded-none text-[14px] font-bold leading-none',
  lg: 'h-11 px-5 rounded-none text-[15px] font-bold leading-none',
}

export const Button = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement> & { variant?: keyof typeof variants; size?: keyof typeof sizes }
>(function Button({ className, variant = 'primary', size = 'md', type = 'button', ...props }, ref) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex items-center justify-center gap-2 whitespace-nowrap transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nk-sea focus-visible:ring-offset-2 focus-visible:ring-offset-white',
        'disabled:pointer-events-none disabled:opacity-35',
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    />
  )
})
